import fp from 'lodash/fp';
import { createSelector } from 'reselect';

export const getColumns = fp.get('visit.columns');

export const getVisitColumnsByName = createSelector(getColumns, fp.get('all'));

export const getIsFetchingVisitColumns = createSelector(
  getColumns,
  fp.get('fetching')
);

export const getIsFetchedVisitColumns = createSelector(
  getColumns,
  fp.get('fetched')
);

export const getFetchingVisitColumnsError = createSelector(
  getColumns,
  fp.get('fetchingError')
);

export const getVisitColumns = createSelector(getVisitColumnsByName, fp.values);

export const getVisitCustomFields = createSelector(
  getVisitColumns,
  fp.pickBy(({ name }) => name.substr(0, 3) === 'cf_')
);
